<template>
  <div class="dqyxfx-warp">
    <div class="left-content" v-show="tabShow">
      <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
    </div>
    <div class="right-content" :style="{width:tabShow?'calc(100% - 260px)':'100%'}">
      <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
      <div class="dn-content-bg box1 zt">
        <label class="jg">改造前:</label>
        <el-date-picker type="datetimerange" v-model="timeInterval" :clearable="false" format="yyyy-MM-dd HH" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
        <label class="jg1">改造后:</label>
        <el-date-picker type="datetimerange" v-model="timeIntervalNew" :clearable="false" format="yyyy-MM-dd HH" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
        <el-button style="height: 30px;line-height: 0px;margin-left:10px" ref="print" type="primary" class="btn" @click="TimeControlClick">查询</el-button>
      </div>
      <div class="hbC">
        <div class="bh-item dn-content-bg">
          <div class="flex">改造前用电量</div>
          <div class="flex item-zt">{{Modification.beforeModification}}kWh</div>
        </div>
        <div class="bh-item dn-content-bg">
          <div class="flex">改造后用电量</div>
          <div class="flex item-zt">{{Modification.afterModification}}kWh</div>
        </div>
        <div class="bh-item dn-content-bg">
          <div class="flex">节能量</div>
          <div class="flex item-zt">{{Modification.energySaving}}kWh</div>
        </div>
        <div class="bh-item dn-content-bg" style="margin-right:0">
          <div class="flex">节能率</div>
          <div class="flex item-zt">{{Modification.energySavingRate}}%</div>
        </div>
      </div>
      <div class="tab-pane ">
        <div class="tap-echarts ">
          <div class="tap-center dn-content-bg">
            <div class="echarts">
              <echarts :echartsData="echartsData" :direction="'top'"></echarts>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  findDataByParam,
} from "@/utils/index.js";
import * as utils from "@/utils/index.js";
import echarts from "./pages/echarts.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import TabTree from "@/components/common/TabTree.vue";
import handleData from "@/utils/handleData.js";
import dateTool from "@/utils/dateTool";
import BtnShow from "@/components/common/BtnShow.vue";
import { isNull, isUndefined } from "util";
export default {
  components: {
    TimeSearch,
    TabTree,
    echarts,
    BtnShow,
  },
  data () {
    return {
      tabShow: true,
      viewTreeData: [],
      Modification: { /* 改造用量 */
        beforeModification: '-',//改造前用量
        afterModification: '-',//改造后用量
        energySaving: '-',//节能量
        energySavingRate: '-',//节能率
      },
      echartsData: {},
      timeInterval: [new Date(), new Date()],
      timeIntervalNew: [new Date(), new Date()],
    };
  },
  created () {
    this.init();
    let timeNew = new Date();
    let time = new Date();
    this.timeInterval[0] = dateTool.format(new Date(), "yyyy-MM-dd ") + "00:00:00";
    timeNew.setDate(timeNew.getDate() + 1);
    this.timeInterval[1] = dateTool.format(timeNew, "yyyy-MM-dd") + " 00:00:00";
    time.setDate(time.getDate() - 1);
    this.timeIntervalNew[0] = dateTool.format(time, "yyyy-MM-dd") + " 00:00:00";
    this.timeIntervalNew[1] = dateTool.format(new Date(), "yyyy-MM-dd") + " 00:00:00";
  },
  watch: {
  },
  methods: {
    init () {
      let vm = this;
      vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(vm.$store.state.user.currentCompanyId, "/nygl/toAndFormNh", null)
        .then(res => {
          if (res) {
            const viewTreeData = findDataByParam("viewTree", true, res.data);
            vm.viewTreeData = viewTreeData;
          }
        });
    },
    /* 树加载 */
    tabTreeDefault (e) {
      this.selectNodes = e;
      this.TimeControlClick();
    },
    /* 树点击 */
    tabTreeClick (e) {
      this.selectNodes = e;
      this.TimeControlClick();
    },
    /* 查询 */
    TimeControlClick () {
      this.getData();
    },
    async getData () {
      let vm = this
      let timeInterval = JSON.parse(JSON.stringify(vm.timeInterval))
      let timeIntervalNew = JSON.parse(JSON.stringify(vm.timeIntervalNew))
      let beforeStartTime = dateTool.format(new Date(timeInterval[0]), "yyyy-MM-dd hh") + ':00:00';
      let beforEendTime = dateTool.format(new Date(timeInterval[1]), "yyyy-MM-dd hh") + ':00:00';
      let afterStartTime = dateTool.format(new Date(timeIntervalNew[0]), "yyyy-MM-dd hh") + ':00:00';
      let afterEendTime = dateTool.format(new Date(timeIntervalNew[1]), "yyyy-MM-dd hh") + ':00:00';
      let beforeDiff = new Date(vm.timeInterval[1]).getTime() - new Date(vm.timeInterval[0]).getTime()
      let afterDiff = new Date(vm.timeIntervalNew[1]).getTime() - new Date(vm.timeIntervalNew[0]).getTime()
      vm.errorData()
      if (afterDiff != beforeDiff) {
        vm.$message.warning('改造前与改造后时间差值间隔须一致')
        return
      }
      let res = await vm.$api.tmp.retrofitCompared(this.selectNodes.measureId, beforeStartTime, beforEendTime, afterStartTime, afterEendTime)
      let obj = {
        legend: [vm.selectNodes.measureName + '改造前', vm.selectNodes.measureName + '改造后'],
        xData: [],
        series: [{ type: 'line', name: vm.selectNodes.measureName + '改造前', data: [] }, { type: 'line', name: vm.selectNodes.measureName + '改造后', data: [] }]
      }
      if (res.success) {
        vm.Modification = res.data
        obj.xData = res.data.xData
        obj.series[0].data = res.data.beforeModificationData
        obj.series[1].data = res.data.afterModificationData
        vm.echartsData = obj
      }
    },
    /* 当接口加载失败时数据还原 */
    errorData () {
      this.echartsData = {
        legend: [],
        xData: [],
        series: [{ type: 'line', name: '改造前', data: [] }, { type: 'line', name: '改造后', data: [] }]
      };
      this.beforeModification = '-';
      this.afterModification = '-';
      this.energySaving = '-';
      this.energySavingRate = '-';
    }
  }
};
</script>
<style  scoped lang="scss">
.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  width: 260px;
  min-width: 200px;
  margin-right: 14px;
}
.right-content {
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
}
.box1 {
  box-sizing: border-box;
  color: #2e3842;
  padding: 10px;
  text-align: left;
  border-radius: 4px;
}
.tab-pane {
  width: 100%;
  height: calc(100% - 208px);
  border-radius: 4px;
  .tap-echarts {
    height: 100%;
    margin-bottom: 14px;
    .tab-top {
      height: 45px;
      line-height: 45px;
      padding: 0 14px;
      box-sizing: border-box;
      text-align: left;
      color: #fff;
      font-size: 20px;
      border-radius: 4px 4px 0px 0px;
    }
    .tap-center {
      width: 100%;
      height: 100%;
      .echarts {
        height: 100%;
        width: 100%;
      }
    }
  }
  .tables {
    height: calc(30% - 14px);
    width: 100%;
  }
}
.jg {
  margin-right: 10px;
}
.jg1 {
  margin-right: 10px;
  margin-left: 20px;
}
.flex {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.big {
  color: #bc635e;
}
.small {
  color: #7fad7d;
}
.hbC {
  height: 120px;
  display: flex;
  color: #acaaae;
  margin: 14px 0;
  .bh-item {
    display: flex;
    width: 25%;
    margin-right: 10px;
    flex-flow: column;
    border-radius: 4px;
    font-size: 18px;
    padding: 6px 10px;
    box-sizing: border-box;
    .bh-item-item {
      display: flex;
      flex: 1;
      flex-flow: column;
    }
    .item-zt {
      font-size: 24px;
      background: #b53b1a;
      border-radius: 4px;
      color: #fff;
    }
  }
}
</style>